import {
    SET_ASSET_FLEET_LINK_ATTACHMENT_SAVE
} from "./AssetFleetProcessingLinkAttachmentType"

const initialState = {
    assetFleetLinkAttachmentSave: []
}


const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ASSET_FLEET_LINK_ATTACHMENT_SAVE:
            return {
                ...state,
                assetFleetLinkAttachmentSave: action.assetFleetLinkAttachmentSave
            };
        default:
            return state;
    }
};

export default reducer;